import { render, staticRenderFns } from "./authorizedModal.vue?vue&type=template&id=113de1d0&"
import script from "./authorizedModal.vue?vue&type=script&lang=js&"
export * from "./authorizedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports